import { createStyles, withStyles, WithStyles } from '@domonda/ui/styles';

const styles = createStyles(({ palette, shadows, spacing, shape }) => ({
  actionBar: {
    display: 'flex',
    borderBottom: `1px solid ${palette.border}`,
    backgroundColor: palette.surface,
    padding: spacing(0, 2),
  },
  content: {
    display: 'flex',
  },
  invoice: {
    border: `2px solid ${palette.primary}`,
    borderRadius: shape.borderRadius,
    backgroundColor: palette.lighter('background'),
  },
  invoicePage: {
    position: 'relative',
    boxShadow: shadows[2],
    backgroundColor: palette.surface,
    border: `1px solid ${palette.border}`,
    overflow: 'hidden',
    borderRadius: shape.borderRadius,

    '&:hover $invoicePageButton': {
      display: 'block',
    },
  },
  invoicePageDeleted: {
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(204, 0, 0, 0.5)',
    },
  },
  invoicePageButton: {
    position: 'absolute',
    left: 0,
    display: 'none',
    width: '100%',
    height: '50%',
    borderRadius: '0',

    '&:focus': {
      outline: 'none',
    },
  },
  invoicePagePreviewButton: {
    top: 0,
    color: palette.surface,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
  },
  invoicePageDeleteButton: {
    bottom: 0,
    color: palette.surface,
    backgroundColor: 'rgba(204, 0, 0, 0.75)',

    '&:hover': {
      backgroundColor: 'rgba(204, 0, 0, 0.75)',
    },
  },
  invoiceSplit: {
    padding: spacing(1),
  },
  invoiceJoin: {
    padding: spacing(1),
  },
  invoicePagePreview: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: 1,
    overflow: 'auto',
    padding: spacing(4),
    textAlign: 'center',
    cursor: 'zoom-out',
  },
  invoicePagePreviewBackdrop: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: -1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}));

export type Decorate = WithStyles<typeof styles>;

export const decorate = withStyles(styles);
